import React from 'react';
interface IconProps {
  width?: number;
  height?: number;
}

const HomeValueIconTweeOnderEenKap = (props: IconProps) => {
  return (
    <svg width={49} height={53} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M39.89 52.222V39h-7.778v13.222M16.556 53V39.777H8.778V53M24.334 14.889S16.305 6.592 12.667 2.444L1.001 14.89M32.112 15.666h7.778v7.778h-7.778zM8.778 16.443h7.778v7.778H8.778zM32.112 27.332h7.778v7.778h-7.778zM8.778 28.111h7.778v7.778H8.778z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.001 17.22V53h46.667V17.22M24.334 17.22v35M15.778 1.666h17.89"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HomeValueIconTweeOnderEenKap;
